
import { BrowserRouter } from 'react-router-dom';
import Navbar from './components/layout/navbar';
import Home from './components/page/home';
import Footer from './components/layout/Footer';

function App() {
  return (
    <>
      <BrowserRouter>
        <Navbar />
        <Home />
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
